import { str } from "@lit/localize";
//#region src/generated/locales/de.ts
var templates = {
	"pd.socialmedia.aria.label": `Social-Media-Profile`,
	"pd.socialmedia.empty": `Keine Einträge`,
	"pd.socialmedia.new.entry": `Neuer Eintrag`,
	"pd.socialmedia.placeholder": `Socialmedia eingeben...`,
	"pd.socialmedia.delete": `Eintrag löschen`,
	"pd.socialmedia.cancel": `Abbrechen`,
	"pd.socialmedia.save": `Speichern`,
	"pd.contact.property.year.selection": `Baujahr auswählen`,
	"pd.contact.address.title": `Adresse`,
	"pd.contact.label.type": `Typ`,
	"pd.contact.check.private": `Privatperson`,
	"pd.contact.check.company": `Unternehmen`,
	"pd.contact.label.company": `Name des Unternehmen`,
	"pd.contact.label.btw": `USt-IdNr.`,
	"pd.contact.label.firstName": `Vorname`,
	"pd.contact.label.lastName": `Nachname`,
	"pd.contact.label.street": `Strasse`,
	"pd.contact.label.streetNr": `Nr.`,
	"pd.contact.label.zip": `PLZ`,
	"pd.contact.label.city": `Ort`,
	"pd.contact.label.additional": `Addresszusatz`,
	"pd.contact.label.propertyDate": `Datum der Immobilie`,
	"pd.contact.label.phone": `Telefon`,
	"pd.contact.label.email": `E-mail`,
	"pd.contact.label.website": `Website`,
	"pd.contact.label.summary.propertyDate": str`Baujahr: ${0}`,
	"pd.markdown.link.url": `Link`,
	"pd.markdown.link.text": `Anzeige-Text`,
	"pd.markdown.link.remove": `Entfernen`,
	"pd.markdown.link.cancel": `Abbrechen`,
	"pd.markdown.link.apply": `Übernehmen`,
	"pd.form.field.invalid.url": `Gültige URL eingeben (z. B. example.com)`,
	"pd.iconPicker.selectIcon": `Icon auswählen`,
	"pd.iconPicker.clearIcon": `Icon entfernen`,
	"pd.iconPicker.placeholder": `Icon auswählen...`,
	"pd.iconPicker.dialogLabel": `Icon auswählen`,
	"pd.iconPicker.search": `Suchen...`,
	"pd.iconPicker.noResults": `Nichts gefunden`,
	"pd.iconPicker.noIcon": `Kein Icon`,
	"pd.iconPicker.recent": `Zuletzt verwendet`,
	"pd.history.kind.created": `Angelegt`,
	"pd.history.kind.updated": `Bearbeitet`,
	"pd.history.kind.deleted": `Gelöscht`,
	"pd.history.kind.restored": `Wiederhergestellt`,
	"pd.history.kind.process": `Vorgang`,
	"pd.history.changes.one": `1 Änderung`,
	"pd.history.changes.many": str`${0} Änderungen`,
	"pd.history.changes.details": str`${0} Details`,
	"pd.history.value.empty": `leer`,
	"pd.history.list.loading": `Historie wird geladen`,
	"pd.history.list.empty": `Noch keine Einträge`,
	"pd.mail.to": `an`,
	"pd.mail.ccHint": `CC/BCC`,
	"pd.mail.details": `Details`,
	"pd.mail.state.success": `Gesendet`,
	"pd.mail.state.error": `Fehlgeschlagen`,
	"pd.mail.state.processing": `Wird gesendet`,
	"pd.mail.state.retry": `Neuer Versuch`,
	"pd.mail.state.pending": `Wartet`,
	"pd.mail.meta.to": `Empfänger`,
	"pd.mail.meta.replyTo": `Antwort an`,
	"pd.mail.meta.attempts": `Versuche`,
	"pd.mail.meta.endTime": `Abgeschlossen`,
	"pd.mail.meta.error": `Fehler`,
	"pd.mail.resend": `Erneut senden`,
	"pd.mail.list.loading": `Mails werden geladen`,
	"pd.mail.list.empty": `Keine Mails vorhanden`,
	"pd.trash.deleted": str`gelöscht ${0}`,
	"pd.trash.by": str`von ${0}`,
	"pd.trash.details": `Details`,
	"pd.trash.list.loading": `Papierkorb wird geladen`,
	"pd.trash.list.empty": `Der Papierkorb ist leer`,
	"pd.trash.row.mark": str`${0} markieren`,
	"pd.trash.select-all": `Alle markieren`,
	"pd.trash.marked-count": str`${0} markiert`,
	"pd.trash.delete": str`Endgültig löschen (${0})`,
	"pd.trash.restore": str`Wiederherstellen (${0})`,
	"pd.chat.item.srOwn": str`Ich, ${0}:`,
	"pd.chat.item.srOther": str`${0}, ${1}:`,
	"pd.chat.input.submit": `Senden`,
	"pd.chat.input.placeholder": `Nachricht schreiben …`,
	"pd.chat.list.label": `Nachrichtenverlauf`,
	"pd.chat.list.empty": `Noch keine Nachrichten`,
	"pd.chat.list.typing": `Antwort wird geschrieben`,
	"pd.rating.stars.label": str`Bewertung: ${0} von 5 Sternen`,
	"pd.rating.stars.pickerLabel": `Bewertung auswählen`,
	"pd.rating.stars.option": str`${0} von 5 Sternen`,
	"pd.rating.overview.loading": `Bewertungen werden geladen`,
	"pd.rating.overview.empty": `Noch keine Bewertungen`,
	"pd.rating.overview.countMixed": str`${0} Berichte · ${1} mit Bewertung`,
	"pd.rating.overview.countOne": `1 Bewertung`,
	"pd.rating.overview.count": str`${0} Bewertungen`,
	"pd.rating.overview.ariaRated": str`Bewertung: ${0} von 5 Sternen, ${1}`,
	"pd.rating.overview.ariaAction": str`${0} — Liste anzeigen`,
	"pd.rating.item.showLess": `Weniger anzeigen`,
	"pd.rating.item.showMore": `Mehr anzeigen`,
	"pd.rating.item.source": `Quelle`,
	"pd.rating.input.starsLabel": `Bewertung (optional)`,
	"pd.rating.input.text": `Erfahrungsbericht`,
	"pd.rating.input.cancel": `Abbrechen`,
	"pd.rating.input.submit": `Bewertung senden`,
	"pd.rating.input.errorText": `Bitte einen Text eingeben.`,
	"pd.rating.list.create": `Bewertung schreiben`,
	"pd.rating.list.loading": `Bewertungen werden geladen`,
	"pd.rating.list.empty": `Noch keine Bewertungen`
};
//#endregion
export { templates };
